/* eslint-disable react/prop-types -- project uses JSX without PropTypes package */
import Card from "../Card";

export default function SizingChartsEmptyState({ onCreate, createDisabled }) {
  return (
    <Card className="flex flex-col items-center justify-center text-center py-16 px-8 gap-3 border border-dashed border-slate-200 bg-slate-50/40">
      <p className="text-lg font-semibold text-[var(--clr-text-title)]">
        No sizing charts yet
      </p>
      <p className="text-sm text-slate-600 max-w-md">
        Sizing charts are assigned to products automatically. However, if you want to adjust a chart for a specific product, this can be done by creating a sizing chart and assigning it to the product.
      </p>
      <button
        type="button"
        className="btn-solid mt-2 min-h-[44px] px-6"
        onClick={onCreate}
        disabled={createDisabled}
        title={
          createDisabled
            ? "Add at least one brand before creating a sizing chart"
            : undefined
        }
      >
        Create Sizing Chart
      </button>
    </Card>
  );
}
